<script setup lang="ts">
import type { HTMLAttributes } from "vue";
import { computed } from "vue";
import { BrainIcon, ChevronDownIcon } from "lucide-vue-next";
import { CollapsibleTrigger } from "@/components/ui/collapsible";
import { cn } from "@/lib/utils";
import { useReasoningContext } from "./context";

interface Props {
  class?: HTMLAttributes["class"];
}

const props = defineProps<Props>();

const { isStreaming, isOpen, duration } = useReasoningContext();

const thinkingMessage = computed(() => {
  if (isStreaming.value || duration.value === 0) {
    return "thinking";
  }
  if (duration.value === undefined) {
    return "default_done";
  }
  return "duration_done";
});
</script>

<template>
  <CollapsibleTrigger
    :class="
      cn(
        'flex w-full items-center gap-2 text-muted-foreground text-sm transition-colors hover:text-foreground',
        props.class,
      )
    "
  >
    <slot>
      <BrainIcon class="size-4" />

      <span
        v-if="thinkingMessage === 'thinking'"
        class="animate-pulse motion-reduce:animate-none"
      >Thinking…</span>

      <p v-else-if="thinkingMessage === 'default_done'">Thought for a few seconds</p>

      <p v-else>Thought for {{ duration }} seconds</p>

      <ChevronDownIcon
        :class="cn('size-4 transition-transform', isOpen ? 'rotate-180' : 'rotate-0')"
      />
    </slot>
  </CollapsibleTrigger>
</template>
